import './HandlebarsHelpers'

var trailerModal = require('../../views/meridian/partials/film/trailer-modal-hbs.hbs')

class TrailerService {

    /**
     * @constructor
     *
     * @param {Array<Object>} films
     */
    constructor(films) {

        /**
         * @type {Array<Object>}
         */
        this.films = films;

        /**
         * @type string
         */
        this.modal              = '#trailer-modal';
        this.initializesTrailer = '.initializes-trailer';

        this.containerMediaplayer  = 'modal-mediaplayer';

        /**
         * @type {Mediaplayer}
         */
        this.mediaplayer = null;

    }

    /**
     * Registers all the events for this service
     *
     * @returns {void}
     */
    bindEvents() {
        this.registerInitTrailerEvent();
        this.registerOnCloseModalEvent();
    }

    /**
     * Registers the init-trailer event
     *
     * @returns {void}
     */
    registerInitTrailerEvent() {
        $(document).on('click', this.initializesTrailer, evt => {
            // retrieve film
            const slug = $(evt.target).data('slug');
            const film = this.getFilmBySlug(slug);

            // render the handlebars-template with the film-context
            this.prepareModal(film);

            // only init mediaplayer if filmId is present
            if (typeof film.detailId === "number") {
                this.initMediaplayerTrailer(film);
            }

            // show modal
            this.showModal();
        });
    }

    /**
     * Registers the on-close modal event
     *
     * @returns {void}
     */
    registerOnCloseModalEvent() {
        $(document).on('hidden.bs.modal', this.modal, evt => {
            console.log('try to destroy');
            this.destroyTrailer();
        });
    }

    /**
     * Initializes the mediaplayer trailer for the given film
     *
     * @param {Object} film
     * @returns {void}
     */

    initMediaplayerTrailer(film) {
        console.log('initializing mediaplayer for film', film.slug);
    }

    /**
     * Prepares the modal for the given film
     *
     * @param {Object} film
     * @returns {void}
     */
    prepareModal(film) {
        $(this.modal).remove();
        $(trailerModal(film)).appendTo('body');
    }

    /**
     * Opens the trailer-modal
     *
     * @returns {void}
     */
    showModal() {
        $(this.modal).modal('toggle');
    }

    /**
     * Destroys the trailer-player
     *
     * @returns {void}
     */
    destroyTrailer() {
        // check which kind of trailer was used and destroy it
        console.log('destroying mediaplayer');
        $(this.modal).remove();
    }

    /**
     * Returns the film for the given slug
     *
     * @param {string} slug
     * @returns {Object}
     */
    getFilmBySlug(slug) {
        if (this.films.hasOwnProperty(slug)) {
            return this.films[slug];
        }
        // returning a fake-object (just in case)
        // - normally it should not get to this point due to disabled trailer-buttons
        return { slug: null, detailId: null, trailer: null, trailertype: null };
    }
}

$(function() {
    $(trailerModal(window)).appendTo('body');

    const trailerService = new TrailerService(window.films || {});

    trailerService.bindEvents();
});
